import { Box, Card, CardContent } from "@mui/material";
import { AppBarChart } from "../Charts/AppBarChart";

export const TopSellingProducts = ({
  isLoading,
  dataSet,
}: {
  isLoading: boolean;
  dataSet: any[];
}) => {
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" fontWeight={"bold"}>
          Top Selling Products
        </Box>
        <AppBarChart isLoading={isLoading} dataSet={dataSet} />
      </CardContent>
    </Card>
  );
};
